import { render } from "./DelegatePopup.vue?vue&type=template&id=e54de124&scoped=true&ts=true"
import script from "./DelegatePopup.vue?vue&type=script&lang=ts"
export * from "./DelegatePopup.vue?vue&type=script&lang=ts"

import "./DelegatePopup.vue?vue&type=style&index=0&id=e54de124&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54de124"]])

export default __exports__